export const APPLICATION_TYPE_LIST = [
	{
		type: 1,
		typeName: "CRADLE",
	},
	{
		type: 2,
		typeName: "DARE",
	},
	{
		type: 3,
		typeName: "EXPERT",
	},
	// {
	// 	type: 0,
	// 	typeName: "ALL",
	// },
];

export const CRADLE_TYPE_ID = 1;
export const DARE_TYPE_ID = 2;
export const EXPERT_TYPE_ID = 3;

export const PROJECT_STATUS_NEW = "APPROVED"; // Approved
export const PROJECT_STATUS_REJECTED = "REJECTED"; // Rejected
export const PROJECT_STATUS_PENDING = "PROCESSING"; // Processing
export const PROJECT_STATUS_ACTIVE = "ACTIVE";
export const PROJECT_STATUS_COMPLETED = "ACCESS_END"; // Completed -> Access End
export const PROJECT_STATUS_INACTIVE = "COMPLETED"; // inacitve -> Completed
export const PROJECT_STATUS_RETURN_FOR_APPROVAL = "STATUS_RETURN_FOR_APPROVAL"; // -> Approved

export const PROJECT_STATUS_ACTIVE_PARAM = "A";

export const PROJECT_STATUS_MAPPING = {
	APPROVED: "Approved",
	REJECTED: "Rejected",
	ACTIVE: "Active",
	PROCESSING: "Processing",
	ACCESS_END: "Access End",
	COMPLETED: "Completed",
	STATUS_RETURN_FOR_APPROVAL: "Submitted",
};

export const APPLICATION_STATUS_MAPPING = {
	withdrawn: "Withdrawn",
	rejected: "Rejected",
	approved: "Approved",
	submitted: "Submitted",
};

export const PROJECT_STATUS_LIST = [
	{
		key: "APPROVED",
		value: "Approved",
	},
	{
		key: "PROCESSING",
		value: "Processing",
	},
	{
		key: "ACTIVE",
		value: "Active",
	},
	{
		key: "ACCESS_END",
		value: "Access End",
	},
	{
		key: "COMPLETED",
		value: "Completed",
	},
];

export const PROJECT_STATUS_LIST_MAPPING = {
	APPROVED: [
		{
			key: "APPROVED",
			value: "Approved",
		},
		{
			key: "PROCESSING",
			value: "Processing",
		},
	],
	PROCESSING: [
		{
			key: "PROCESSING",
			value: "Processing",
		},
		{
			key: "ACTIVE",
			value: "Active",
		},
		{
			key: "COMPLETED",
			value: "Completed",
		},
	],
	ACTIVE: [
		{
			key: "ACTIVE",
			value: "Active",
		},
		{
			key: "ACCESS_END",
			value: "Access End",
		},
	],
	ACCESS_END: [
		{
			key: "ACTIVE",
			value: "Active",
		},
		{
			key: "ACCESS_END",
			value: "Access End",
		},
		{
			key: "COMPLETED",
			value: "Completed",
		},
	],
};

export const APPLICATION_STATUS_SUBMITTED = "submitted"; // submitted
export const APPLICATION_STATUS_REJECTED = "rejected";
export const APPLICATION_STATUS_WITHDRAWN = "withdrawn";
